/**
 * A class that describes data for a sortable table header.
 */
export class TableHeader {
  title: string;
  name: string;
  sortable: boolean;

  /**
   * @param title The title of a header.
   * @param name A column name, why which the table might be sorted.
   * @param sortable `True`, if table sorting is enabled.
   */
  constructor(title: string, name: string, sortable: boolean) {
    this.title = title;
    this.name = name;
    this.sortable = sortable;
  }
}
